import { render, staticRenderFns } from "./AccuracyRow.vue?vue&type=template&id=45a211af&scoped=true&"
import script from "./AccuracyRow.vue?vue&type=script&lang=js&"
export * from "./AccuracyRow.vue?vue&type=script&lang=js&"
import style0 from "./AccuracyRow.vue?vue&type=style&index=0&id=45a211af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a211af",
  null
  
)

export default component.exports